import CustomerManagement from './CustomerManagement.vue'

export default CustomerManagement


// WEBPACK FOOTER //
// ./src/pages/CustomerManagement/index.js